// Nomes persistidos em Telas são contratos de navegação. Os aliases mantêm IDs/permissões.
const aliases = {
  comercialidentidade: "ComercialIdentidade",
  comercialclientes: "ComercialClientes",
  comercialfornecedores: "ComercialFornecedores",
  comercialreferencias: "ComercialReferencias",
  comercialparametrosfinanceiros: "ComercialParametrosFinanceiros",
  comercialprodutos: "ComercialProdutos",
  comercialvariantes: "ComercialVariantes",
  comercialembalagens: "ComercialEmbalagens",
  comercialkits: "ComercialKits",
  comercialpromocoes: "ComercialPromocoes",
  comercialestoque: "ComercialEstoque",
  comerciallotes: "ComercialLotes",
  comercialinventarios: "ComercialInventarios",
  comercialservicos: "ComercialServicos",
  comercialpacotes: "ComercialPacotes",
  comercialcolaboradores: "ComercialColaboradores",
  comercialdisponibilidade: "ComercialDisponibilidade",
  comercialcomissoes: "ComercialComissoes",
  comercialreposicao: "ComercialReposicao",
  comercialcotacoes: "ComercialCotacoes",
  comercialpedidoscompra: "ComercialPedidosCompra",
  comercialentradas: "ComercialEntradas",
  comercialcontaspagar: "ComercialContasPagar",
  comercialcontasreceber: "ComercialContasReceber",
  comercialfluxocaixa: "ComercialFluxoCaixa",
  comercialreconciliacao: "ComercialReconciliacao",
  comercialauditoria: "ComercialAuditoria",

  sprint1workspace: "CommercialFoundation", sprint2workspace: "CommercialCatalog", sprint3workspace: "CommercialManagement",
  produtosindustria: "Produtos", produtos: "Produtos", produto: "Produto",
  produtovarejo: "ProdutoVarejo", produtosvarejo: "ProdutosVarejo", produtosvarejocadastro: "ProdutosVarejo",
  fornecedoresvarejo: "Fornecedores",
  pedido: "PedidoVenda", pedidos: "PedidoVenda", pedidovenda: "PedidoVenda",
  os: "OS", ordemproducao: "OS", ordensdeservico: "OS", ppcp: "PPCP",
  expedicao: "Expedicao", motoristas: "Motoristas", etiqueta: "Etiqueta", etiquetas: "Etiqueta",
  operadoresindustriais: "OperadoresIndustriais", operacaoindustrial: "OperacaoIndustrial",
  configuracaoindustrial: "ConfiguracaoIndustrial", dashboardgestaoindustrial: "DashboardGestaoIndustrial",
  dashproducao: "DashboardGestaoIndustrial", dashprogramacao: "PPCP",
  dashexpedicao: "DashboardGestaoIndustrial", dashcomercial: "DashboardGestaoIndustrial",
  beleza: "BelezaDashboard", belezamodulo: "BelezaDashboard", belezaclientes: "BelezaClientes",
  belezaservicos: "BelezaServicos", belezacolaboradores: "BelezaCadastros", belezaprodutos: "BelezaProdutos",
  belezawhatsapp: "BelezaWhatsAppMeta", belezapacotes: "BelezaPacotes", belezapromocoes: "BelezaPromocoes",
  varejo: "VarejoDashboard", varejodashboard: "VarejoDashboard",
  caixas: "PdvCaixas", pdvcaixas: "PdvCaixas", pdv: "PdvTerminal", pdvterminal: "PdvTerminal",
  clientesvarejo: "ClientesVarejo", carteirasvarejo: "CarteirasVarejo",
  formaspagamento: "FormasPagamentoVarejo", formaspagamentovarejo: "FormasPagamentoVarejo",
  classesfiscais: "ClassesFiscais", ncm: "NcmVarejo", ncmvarejo: "NcmVarejo",
  promocoes: "PromocoesVarejo", promocoesvarejo: "PromocoesVarejo",
  estoquvarejo: "EstoqueVarejo", estoquevarejo: "EstoqueVarejo", movimentacoesestoque: "MovimentacoesEstoque",
  listascompra: "ListasCompra", cotacoes: "CotacoesVarejo", cotacoesvarejo: "CotacoesVarejo",
  vendasvarejo: "VendasVarejo", fiscalvarejo: "FiscalVarejo",
  pdvconfiguracoes: "PdvConfiguracoes", pdvdiagnostico: "PdvDiagnostico", pdvpermissoes: "PdvPermissoes",
  varejogerencial: "VarejoGerencial", varejorelatorios: "VarejoRelatorios",
  importacaoprodutosvarejo: "ImportacaoProdutosVarejo", gruposvarejo: "GruposVarejo", subgruposvarejo: "SubgruposVarejo",
};
export const screenKey = value => String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
export const canonicalScreen = value => aliases[screenKey(value)] || String(value || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, "");
export function flattenScreens(permissions = []) {
  if (!Array.isArray(permissions)) return [];
  return permissions.filter(Boolean).flatMap(module => Array.isArray(module.telas)
    ? module.telas.filter(Boolean).map(tela => ({
      ...tela,
      moduloId: module.moduloId || module.id,
      moduloNome: module.moduloNome || module.nome,
      moduloLabel: module.moduloLabel || module.label,
      moduloIcone: module.moduloIcone || module.icone,
    })) : [module])
    .map(tela => ({ ...tela,
      telaId: tela.telaId || tela.id,
      telaNome: tela.telaNome || tela.nome || tela.component,
      telaLabel: tela.telaLabel || tela.label,
      telaIcone: tela.telaIcone || tela.icone,
    })).filter(tela => tela.telaNome);
}
// Screen aliases are for loading legacy components, not for expanding grants.
// Two different records that happen to resolve to the same page are not equivalent ACLs.
export const permittedScreen = (permissions, screen) => Boolean(screenKey(screen)) && flattenScreens(permissions).some(tela =>
  screenKey(tela.telaNome || tela.nome || tela.component) === screenKey(screen));
// Entradas estáticas do salão: Webpack inclui esses módulos no build e gera chunks
// próprios. Não dependem de varredura em runtime nem de rotas das outras soluções.
const salonScreenLoaders = Object.freeze({
  BelezaClientes: () => import(/* webpackChunkName: "salon-clientes" */ "../pages/BelezaClientes"),
  BelezaProdutos: () => import(/* webpackChunkName: "salon-produtos" */ "../pages/BelezaProdutos"),
  BelezaServicos: () => import(/* webpackChunkName: "salon-servicos" */ "../pages/BelezaServicos"),
  BelezaPacotes: () => import(/* webpackChunkName: "salon-pacotes" */ "../pages/BelezaPacotes"),
  BelezaPromocoes: () => import(/* webpackChunkName: "salon-promocoes" */ "../pages/BelezaPromocoes"),
});
export async function loadScreen(name) {
  const component = canonicalScreen(name);
  if (!component) throw new Error("Tela não informada.");
  if (Object.prototype.hasOwnProperty.call(salonScreenLoaders, component)) return salonScreenLoaders[component]();
  if (component === "LoginFilter") return import("../components/LoginFilter/index");
  if (component === "PedidoOracao") return import("../pages/Fe/PedidoOracao");
  if (component === "Testemunho") return import("../pages/Fe/Testemunho");
  // Limita os chunks aos pontos de entrada. Helpers e testes de páginas não são telas.
  const folders = require.context("../pages", true, /^\.\/[^/]+\/index\.(js|jsx)$/, "lazy");
  const roots = require.context("../pages", false, /^\.\/[^/]+\.(js|jsx)$/, "lazy");
  for (const extension of ["js", "jsx"]) {
    const folder = `./${component}/index.${extension}`;
    if (folders.keys().includes(folder)) return folders(folder);
    const root = `./${component}.${extension}`;
    if (roots.keys().includes(root)) return roots(root);
  }
  throw new Error(`Componente não cadastrado: ${component}`);
}


// Formulários herdam exclusivamente a concessão efetiva da respectiva listagem.
// Não cria bypass para root/administrador; a API continua sendo autoridade final.
export const screenCrudParents = Object.freeze({
  Tela: ['Telas'],
  Modulo: ['Modulos'],
  Versao: ['VersaoSistema'],
  Segmento: ['Segmentos'],
  Perfil: ['Perfis'],
  Usuario: ['Usuarios'],
  SetorUsuario: ['SetoresUsuario'],
});

// Uso exclusivo na navegação. CRUD/API devem validar permissões no servidor.
export const permittedNavigationScreen = (permissions, screen) => {
  if (permittedScreen(permissions, screen)) return true;
  const component = canonicalScreen(screen);
  return (screenCrudParents[component] || []).some(parent => permittedScreen(permissions, parent));
};
